// ### Imports
// * Import lib
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Divider, Icon, Popover, Stack } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";

// * Import Kit
import Box from "../../kit/Box";
import Typography from "../../kit/Typography";
import Button from "../../kit/Button";

// * Import images
import avatar from "../../../assets/images/Avatar.svg";
import ThemeSwitchButton from "../ThemeProviderComponent/ThemeProviderComponent";

import APP_CONSTANTS from "../../utils/config";

// ### Styles
const Root = styled(Box)(({ theme }) => ({}));
const UserInfoRoot = styled(Box)(({ theme }) => ({}));
const TypographyProfile = styled(Typography)(({ theme }) => ({
  fontWeight: theme.fontWeight[400],
  fontSize: theme.size[12],
  lineHeight: theme.size[18],
  margin: "5px !important",
  color: theme.palette.cards.heading,
}));

// ### Helper Component
function Avatar(props) {
  const { onClick = () => {} } = props;
  const theme = useTheme();
  return (
    <Icon
      className="material-icons-outlined"
      sx={{
        fontSize: theme.size[26],
        width: theme.size[26],
        height: "auto",
        cursor: "pointer",
        fontWeight: theme.fontWeight[500],
        color: theme.palette.cards.heading,
        "&:hover": {
          color: theme.palette.cards.heading,
        },
        marginLeft: theme.size[6],
      }}
      onClick={onClick}
    >
      person
    </Icon>
  );
}

// ### Main Component
function UserInfo(props = {}) {
  const urlPath = window.location.pathname;
  const navigate = useNavigate();
  const theme = useTheme();
  // ### States
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // ### Selectors
  const userInfo = useSelector((state) => state.auth.metadata);
  const manageProfileFlag = useSelector(
    (state) => state.auth.metadata.profile_flag
  );

  // ### Event Handlers
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const isQuickTourDisabled = () => {
  //   if (
  //     urlPath.includes("discover") ||
  //     urlPath.includes("assist") ||
  //     urlPath.includes("account-setup")
  //   ) {
  //     return false;
  //   }
  //   return true;
  // };

  // ### JSX
  return (
    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
      <Root>
        <Avatar
          onClick={handleClick}
          avatar={avatar}
          userInfo={userInfo.name}
        />
      </Root>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        style={{ margin: theme.size[5] }}
      >
        <UserInfoRoot>
          <Stack
            sx={{
              padding: "10px 10px 5px 10px",
              background: theme.palette.header.main,
            }}
          >
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ mb: theme.size[10] }}
            >
              <Avatar userInfo={userInfo.name} />
              <TypographyProfile>{userInfo.email}</TypographyProfile>
            </Stack>
            {/* <Divider sx={{ margin: theme.margin[5] }} /> */}
            {/* <Button
              style={{
                fontWeight: theme.fontWeight[400],
                fontSize: theme.size[12],
                lineHeight: theme.size[40],
                color: theme.palette.cards.heading,
                cursor: "pointer",
                margin: "0px 5px",
                padding: "0px",
                justifyContent: "flex-start",
                display: "flex",
                paddingLeft: "8px",
              }}
              disabled={isQuickTourDisabled()}
              onClick={() => {
                setAnchorEl(null);
                dispatch(updateUserJourney(true));
              }}
            >
              Quick Tour
            </Button> */}
            {manageProfileFlag?.toLowerCase() === APP_CONSTANTS?.YES_FLAG && (
              <>
                <Divider sx={{ margin: theme.margin[5] }} />
                <Typography
                  sx={{
                    fontWeight: theme.fontWeight[400],
                    fontSize: theme.size[12],
                    lineHeight: theme.size[40],
                    color: theme.palette.cards.heading,
                    cursor: "pointer",
                    margin: "0px 5px",
                  }}
                  onClick={() => navigate("/manage-profile")}
                >
                  Manage Profile
                </Typography>
              </>
            )}
            <Divider sx={{ margin: theme.margin[5] }} />
            <ThemeSwitchButton />
            <Divider sx={{ margin: theme.margin[5] }} />
            <Button
              disableRipple
              href="/api/logout"
              variant="text"
              color="secondary"
              style={{ fontSize: theme.size[11], padding: "4px 0 0 0" }}
            >
              Logout
            </Button>
          </Stack>
        </UserInfoRoot>
      </Popover>
    </Box>
  );
}

// ### Exports
export default UserInfo;
